import React from "react";
import { createRoot } from "react-dom/client";
import "./css/index.css";
import App from "./App";

import { storyblokInit, apiPlugin } from "@storyblok/react";

import Page from "./components/Page";
import Teaser from "./components/Teaser";
import Grid from "./components/Grid";
import Feature from "./components/Feature";
import MenuLink from "./components/menuLink";
import Config from "./components/Config";
import Hero from "./components/homepage/Hero";
import Intro from "./components/homepage/intro";
import CharityLogos from "./components/homepage/homecharitylogos";
import Solutions from "./components/homepage/solutions";
import Article from "./components/article/article";
import ArticleSection from "./components/article/articlesection";
import ArticleResults from "./components/article/articleresults";
import YouTubeEmbed from "./components/youtube";
import BlogPost from "./components/blog/blogpost";
import ContactSection from "./components/contactsection";
import Footer from "./components/footer";
import SolutionSingle from "./components/solutions/solutionsingle";
import DynamicsForm from "./components/dynamicsform";
import TextBlock from "./components/textblock";
import ImageBlock from "./components/imageblock";
import Card from "./components/card";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { FeaturedArticles } from "./components/homepage/FeaturedArticles";
import { FeaturedPosts } from "./components/homepage/FeaturedPosts";
import ArticleOverview from "./components/article/ArticleOverview";
import BlogOverview from "./components/blog/BlogOverview";
import CardNoImage from "./components/cardnoimage";
import Integrations from "./components/integrations";
import { ErrorElement } from "./components/ErrorElement";
import { FooterBuffer } from "./components/FooterBuffer";
import Nonprofitfeatures from "./components/nonprofitfeatures";
import Stats from "./components/homepage/stats";
import FitnessFundraising from "./components/fitnessfundraising";
import ParentPage from "./parentpage";
import HeaderBlock from "./components/headerblock";
import PageNoDemo from "./components/pagenodemo";
import LinkableCard from "./components/linkablecard";
import CardHero from "./components/cardhero";
import P2PFundraising from "./components/p2pfundraising";
import ButtonBlock from "./components/buttonblock";
import LandingPage from "./components/landingpage";
import HeaderBlockLanding from "./components/headerblocklanding";
import LandingPageContent from "./components/landingpage-pc";
import BlogResource from "./components/blogresource";

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_TOKEN,
  components: {
    page: Page,
    teaser: Teaser,
    grid: Grid,
    feature: Feature,
    menulink: MenuLink,
    config: Config,
    hero: Hero,
    intro: Intro,
    homecharitylogos: CharityLogos,
    solutions: Solutions,
    article: Article,
    articlesection: ArticleSection,
    articleresults: ArticleResults,
    youtube: YouTubeEmbed,
    blogpost: BlogPost,
    contactsection: ContactSection,
    solutionsingle: SolutionSingle,
    footer: Footer,
    dynamicsform: DynamicsForm,
    imageblock: ImageBlock,
    textblock: TextBlock,
    card: Card,
    "featured-articles": FeaturedArticles,
    "featured-posts": FeaturedPosts,
    "article-overview": ArticleOverview,
    "blog-overview": BlogOverview,
    cardnoimage: CardNoImage,
    integrations: Integrations,
    "footer-buffer": FooterBuffer,
    nonprofitfeatures: Nonprofitfeatures,
    stats: Stats,
    fitnessfundraising: FitnessFundraising,
    parentpage: ParentPage,
    headerblock: HeaderBlock,
    pagenodemo: PageNoDemo,
    linkablecard: LinkableCard,
    cardhero: CardHero,
    p2pfundraising: P2PFundraising,
    buttonblock: ButtonBlock,
    landingpage: LandingPage,
    headerblocklanding: HeaderBlockLanding,
    landingpagecontent: LandingPageContent,
    blogresource: BlogResource
  },
  use: [apiPlugin],
  apiOptions: {
    // for spaces located in the US or China:
    // region: "us" or "cn", // you need to specify the region
    region: "eu",
  },
});

const router = createBrowserRouter([
  {
    index: true,
    Component: App,
    errorElement: <ErrorElement />,
  },
  {
    path: "/*",
    Component: App,
  },
]);

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
